export default $common => {
  const getNum = () => Math.abs($common.num)

  const getSample = () => $common.sample

  return { getNum, getSample }
}
